{{#if hasTiles}}
    <div class="dashboard-header">
        <h4 class='page-title p-b-10'>{{TR 'Dashboard'}}</h4>
        <div class="btn-group">
            <button id="js-refresh-dashboard" class="btn btn-default"><i class="fa fa-refresh"></i></button>
        </div>
    </div>
{{/if}}
<div class='{{#if isFullscreen}}dashboard-no-grid{{else}}dashboard-grid{{/if}}'>
    {{#each tiles}}
        <article
            id='js-tile-{{region}}'
            class='card-box grid-span-row-{{height}} grid-span-col-{{width}}'
        >
        </article>
    {{else}}
        <div class='card-box grid-span-row-12 grid-span-col-12'>
            <h4>{{TR 'Keine Dashboardeinstellungen vorhanden'}}</h4>
            <p>{{TR 'Momentan ist kein Dashboard konfiguriert.'}}</p>
        </div>
    {{/each}}
</div>
